<template>
  <el-dialog
    v-el-drag-dialog
    no="dialog"
    :visible.sync="innerVisible"
    :title="$t('queryJob.completeBooking')"
    width="800px"
    :close-on-click-modal="false"
    class="booking-done"
  >
    <cargo-up-down-resize
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
      style="height: 100%;"
    >
      <template slot="up">
        <cargo-ag-grid
          no="up-grid"
          :grid-options="up.gridOptions"
          :column-defs="up.columnDefs"
          :row-data="up.rowData"
          style="min-height: 200px;"
          @gridReady="params=>{up.gridApi=params.api}"
        />
      </template>
      <template slot="down">
        <cargo-ag-grid
          no="down-grid"
          :grid-options="down.gridOptions"
          :column-defs="down.columnDefs"
          :row-data="down.rowData"
          style="min-height: 200px;"
          @gridReady="params=>{down.gridApi=params.api}"
        />
      </template>
    </cargo-up-down-resize>
    <span slot="footer">
      <el-button no="Close" @click="innerVisible=false">{{ $t('Message.Close') }}</el-button>
    </span>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </el-dialog>
</template>

<script>
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import { queryBooking, updateBooking } from '@/api/AirExport/aeBooking'

export default {
  name: 'BookingDoneDialog',
  components: { cargoUpDownResize, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    flight: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      up: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          onRowDataChanged: event => {
            /* 清除单选行 */
            this.selectedNode = null
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            // 重置单选行
            if (this.selectedNode) {
              const rowIndex = this.selectedNode.rowIndex
              this.selectedNode = null
              event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('queryJob.bookingNumber'),
            field: 'bookingNo',
            width: 100
          }, {
            headerName: this.$t('queryJob.bookingTime'),
            field: 'bookingDate',
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 100
          }, {
            headerName: this.$t('queryJob.descriptionOfBookingResults'),
            field: 'bookingResultNotes',
            width: 450
          }, {
            headerName: this.$t('Payment.operation'),
            width: 100,
            cellRenderer: params => {
              const clickHandlerMethod = this.documentManage.getPath('clickHandler')
              const printHandlerMethod = this.documentManage.getPath('printHandler')
              const operateTxt = params.data.bookingState === 1 ? this.$t('Message.Cancel') : this.$t('SeaExport.Completed')
              return `<a href="javascript:void(0)"  style="border-bottom: 1px solid;" onclick="${clickHandlerMethod}(event)">${operateTxt}</a>` +
                `&nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)"  style="border-bottom: 1px solid;" onclick="${printHandlerMethod}(event)">${this.$t('SeaExport.print')}</a>`
            }
          }
        ],
        rowData: [],
        gridApi: null
      },
      down: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BookingSuccess'),
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            width: 100
          }, {
            headerName: this.$t('Payment.customer'),
            field: 'customerId',
            cellRenderer: params => {
              if (params.data.airExportJob) {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.airExportJob.customerId, 'chineseName')
              }
              return ''
            },
            width: 150
          }, {
            headerName: this.$t('Billing.WayBillNumber'),
            field: 'mbl',
            cellRenderer: params => {
              if (params.data.airExportJob) {
                return params.data.airExportJob.mbl
              }
              return ''
            },
            width: 100
          }, {
            headerName: this.$t('Payment.portOfDestination'),
            field: 'destinationPortCode',
            cellRenderer: params => {
              if (params.data.airExportJob) {
                return params.data.airExportJob.destinationPortCode
              }
              return ''
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.Quantity'),
            field: 'quantityBooking',
            cellRenderer: params => {
              if (params.data.airExportJob) {
                return ColumnUtils.formatNumber(params.data.airExportJob.quantityBooking, 0, true)
              }
              return ''
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.Weight2'),
            field: 'weightBooking',
            cellRenderer: params => {
              if (params.data.airExportJob) {
                return ColumnUtils.formatNumber(params.data.airExportJob.weightBooking, 1, true)
              }
              return ''
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            field: 'cubageBooking',
            cellRenderer: params => {
              if (params.data.airExportJob) {
                return ColumnUtils.formatNumber(params.data.airExportJob.cubageBooking, 3, true)
              }
              return ''
            },
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      selectedNode: null,
      documentManage: new DocumentManage(),
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        queryBooking({ flightUuid: this.flight.uuid }).then(res => {
          this.up.rowData = res.data
          if (this.up.rowData.length > 0) {
            setTimeout(() => {
              this.up.gridApi.setFocusedCell(0, this.gridApi.columnController.getAllDisplayedColumns()[0])
            }, 100)
          }
        })
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.up.rowData = []
        this.down.rowData = []
        this.selectedNode = null
      }
    },
    selectedRow(newVal) {
      if (newVal) {
        this.down.rowData = newVal.airExportBookingItem
        setTimeout(() => {
          const nodes = this.down.gridApi.rowModel.rowsToDisplay
          for (const item of nodes) {
            item.setSelected(item.data.success)
          }
        }, 100)
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('clickHandler', function(e) {
      self.clickHandler(e)
    })
    this.documentManage.set('printHandler', function(e) {
      self.printHandler(e)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    clickHandler(e) {
      stopBubble(e)
      const nodes = this.up.gridApi.rowModel.rowsToDisplay
      const cell = this.up.gridApi.getFocusedCell()
      const row = nodes[cell.rowIndex].data
      const oldBookingState = row.bookingState
      if (row.bookingState === 1) {
        row.bookingState = 0
      } else {
        row.bookingState = 1
      }
      updateBooking(row, { selectiveType: 'bookingState' }).then(res => {
        Object.assign(row, res.data)
        this.up.gridApi.refreshCells({ force: true })
      }).catch(() => {
        row.bookingState = oldBookingState
      })
    },
    printHandler(e) {
      stopBubble(e)
      const nodes = this.up.gridApi.rowModel.rowsToDisplay
      const cell = this.up.gridApi.getFocusedCell()
      const row = nodes[cell.rowIndex].data
      const jobKeys = Array.from(row.airExportBookingItem, p => p.airExportJobUuid)
      this.templateSelectorDialog.category = 'AELIST'
      this.templateSelectorDialog.data = { 'USER_ID': this.$store.getters.userInfo.userId, 'JOB_UUID': jobKeys }
      this.templateSelectorDialog.visible = true
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
#app .booking-done ::v-deep {
  .ag-theme-balham {
    .ag-selection-checkbox {
      padding-left: 40px;
    }
  }
}
</style>
